import React from 'react'
import {connect} from 'react-redux'
import {UniLink} from '../unilink/index'
import {selectSuggestions} from '../../../redux/modules/searchSuggestions'
import {getTrendingTopics} from '../../../redux/modules/search'
import {toggleSearchIsFocused} from '../../../redux/modules/ui'
import {toJS} from '../../../util/ToJS'
import qs from 'query-string'
import {withRouter} from 'react-router'
import './searchboxSuggestions.css'

function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
}

class SearchSuggestions extends React.PureComponent {

  render() {
    const {isEnabled, suggestions, getTrendingTopics, query, isFetching, didGetResults, isFocused, cursor, currQuery, goToPath} = this.props
    if (isEnabled) {

      // We fetch trending topics only after user clicks on the search bar.
      // Also, this should only happen once per page load.
      if (!suggestions.length) {
        getTrendingTopics()
      }

      const classNames = ['searchbox-suggestions']
      if (isFocused) {
        classNames.push('searchbox-suggestions--active')
      }
      const re = new RegExp(`${escapeRegExp(query)}`, 'gi') //for bolding
      const renderedCurrQuery = cursor > -1 ? suggestions[cursor].renderedTitle : currQuery
      const latexCurrQuery = cursor > -1 ? suggestions[cursor].title : currQuery

      if (isFetching) {
        return (
          <div className={classNames.join(' ')}>
            <ul className='searchbox-suggestions__results'>
              <li className='searchbox-suggestions__title'> Loading </li>
            </ul>
          </div>
        )
      } else if (query.length && didGetResults) {
        return (
          <div className={classNames.join(' ')}>
            <ul className='searchbox-suggestions__results'>
              <li className='searchbox-suggestions__title'> Suggestions </li>
              {
                suggestions.map((titles, index) => {
                  const highlightedTitle = titles.renderedTitle.replace(re,m => `<b>${m}</b>`)
                  const q = {
                    q: titles.title
                  }
                  return (
                    <li
                      key={titles.title}
                      className={cursor === index ? 'searchbox-suggestions__suggestion-container searchbox-suggestions__suggestion-container--active' : 'searchbox-suggestions__suggestion-container'}>
                      <UniLink
                        className='searchbox-suggestions__suggestion'
                        to={`/search?${qs.stringify(q)}`}>
                        <span
                          dangerouslySetInnerHTML={{__html:highlightedTitle}} />
                      </UniLink>
                    </li>
                  )
                })
              }
            </ul>
            <div className='searchbox-suggestions__foot'>
              <UniLink
                className='searchbox-suggestions__viewall'
                dangerouslySetInnerHTML={{__html:`View all search results for <br> "${renderedCurrQuery}"`}}
                to={`/search?${qs.stringify({q:latexCurrQuery})}`} />
            </div>
          </div>
        )
      } else if (query.length && !didGetResults) {
        return (
          <div className={classNames.join(' ')}>
            <ul className='searchbox-suggestions__results'>
              <li className='searchbox-suggestions__title'> No Results </li>
            </ul>
            <div className='searchbox-suggestions__foot'>
              <span
                className='searchbox-suggestions__viewall'
                dangerouslySetInnerHTML={{__html:`Try another query`}} />
            </div>
          </div>
        )
      } else {
        return (
          <div className={classNames.join(' ')}>
            <ul className='searchbox-suggestions__results'>
              <li className='searchbox-suggestions__title'> Trending Topics </li>
              {
                suggestions.map((titles, index) => {
                  const highlightedTitle = titles.renderedTitle
                  /*const q = {
                    q: titles.title
                  }*/
                  return (
                    <li
                      key={titles.title}
                      className={cursor === index ? 'searchbox-suggestions__suggestion-container searchbox-suggestions__suggestion-container--active' : 'searchbox-suggestions__suggestion-container'}>
                      <UniLink
                        className='searchbox-suggestions__suggestion'
                        onClick={()=>{
                          goToPath(titles.slug)
                        }} >
                        <span
                          dangerouslySetInnerHTML={{__html:highlightedTitle}} />
                      </UniLink>
                    </li>
                  )
                })
              }
            </ul>
            <div className='searchbox-suggestions__foot'>
              <UniLink
                className='searchbox-suggestions__viewall'
                dangerouslySetInnerHTML={{__html:`View all trending topics`}}
                to={`/search`} />
            </div>
          </div>
        )
      }
    }
    return null
  }
}
const mapStateToProps = (state) => (
  {
    isFocused: state.getIn(['ui','searchIsFocused']),
    ...selectSuggestions(state)
  }
)
const mapDispatchToProps = (dispatch, {history}) => (
  {
    goToPath: (path) => {
      dispatch(toggleSearchIsFocused(false))
      history.push(path)
    },
    getTrendingTopics: () => dispatch(getTrendingTopics())
  }
)
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(SearchSuggestions)))



// WEBPACK FOOTER //
// ./src/core/components/search-box/SearchSuggestions.js